"use client";

import { atom, useAtom, useAtomValue } from "jotai";
import { useEffect } from "react";

import { getPerpConstraints } from "#/config/orders";
import { useMarketIndexPrice } from "#/store/app/indexPrices/marketIndexPrice";
import { useMarket } from "#/store/app/portfolio/market";
import { roundToNearest } from "#/utils/number.utils";

import { usePerpUnit } from "./perpUnit";

export const perpSizeInputValueAtom = atom<string>("");

export const perpSizeAtom = atom<string>("");

export const perpSizeNumAtom = atom((get) => Number(get(perpSizeAtom)));

export const usePerpSize = () => {
  const [perpSizeInputValue, setPerpSizeInputValue] = useAtom(
    perpSizeInputValueAtom,
  );
  const [perpSize, setPerpSize] = useAtom(perpSizeAtom);
  const perpSizeNum = useAtomValue(perpSizeNumAtom);
  const { market } = useMarket();
  const { isUnderlyingSelected } = usePerpUnit();
  const { throttledMarketIndexPrice } = useMarketIndexPrice();

  useEffect(() => {
    if (!isUnderlyingSelected || isNaN(throttledMarketIndexPrice)) {
      if (isNaN(Number(perpSizeInputValue))) {
        setPerpSize("");
      }

      const value = roundToNearest(
        Number(perpSizeInputValue) / throttledMarketIndexPrice,
        Math.pow(
          10,
          -getPerpConstraints(market.underlying).sizeDisplayPrecision,
        ),
      );

      setPerpSize(value ? value.toString() : "");
      return;
    }

    setPerpSize(perpSizeInputValue ?? "");
  }, [
    throttledMarketIndexPrice,
    perpSizeInputValue,
    isUnderlyingSelected,
    market.underlying,
    setPerpSize,
  ]);

  return {
    perpSize,
    perpSizeNum,
    perpSizeInputValue,
    setPerpSizeInputValue,
  };
};
